// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Add all variables here */
:host {
  display: inline-block;
  width: 100%;
}

div.breadcrumbs {
  display: flex;
  align-items: center;
  height: 30px;
  font-size: 0.75rem;
  color: #808080;
}
div.breadcrumbs.light {
  color: #fff;
  opacity: 0.6;
}
div.breadcrumbs.light .item-list ol.breadcrumb-list li a {
  color: #fff;
}
div.breadcrumbs .item-list {
  display: flex;
}
div.breadcrumbs .item-list > span {
  display: inline-block;
  margin-right: 5px;
}
div.breadcrumbs .item-list ol.breadcrumb-list {
  display: flex;
  flex-direction: row;
  padding: 0;
  margin: 0;
  list-style: none;
}
div.breadcrumbs .item-list ol.breadcrumb-list li {
  font-weight: bold;
}
div.breadcrumbs .item-list ol.breadcrumb-list li:not(.first):before {
  content: "→";
  display: inline-block;
  margin: 0 5px;
  font-weight: 300;
}
div.breadcrumbs .item-list ol.breadcrumb-list li a {
  color: #808080;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/general/breadcrumbs/breadcrumbs.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,2BAAA;ADIA;EACE,qBAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,YC0BkB;EDzBlB,kBAAA;EACA,cAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;AADJ;AAMU;EACE,WAAA;AAJZ;AAWE;EACE,aAAA;AATJ;AAWI;EACE,qBAAA;EACA,iBAAA;AATN;AAYI;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAVN;AAYM;EACE,iBAAA;AAVR;AAYQ;EACE,YAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AAVV;AAaQ;EACE,cAAA;EACA,iBAAA;AAXV","sourcesContent":["@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n\n:host {\n  display: inline-block;\n  width: 100%;\n}\n\ndiv.breadcrumbs {\n  display: flex;\n  align-items: center;\n  height: $breadcrumb-height;\n  font-size: 0.75rem;\n  color: #808080;\n\n  &.light {\n    color: #fff;\n    opacity: 0.6;\n\n    .item-list {\n      ol.breadcrumb-list {\n        li {\n          a {\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n\n  .item-list {\n    display: flex;\n\n    > span {\n      display: inline-block;\n      margin-right: 5px;\n    }\n\n    ol.breadcrumb-list {\n      display: flex;\n      flex-direction: row;\n      padding: 0;\n      margin: 0;\n      list-style: none;\n\n      li {\n        font-weight: bold;\n\n        &:not(.first):before {\n          content: '→';\n          display: inline-block;\n          margin: 0 5px;\n          font-weight: 300;\n        }\n\n        a {\n          color: #808080;\n          font-weight: bold;\n        }\n      }\n    }\n  }\n}\n\n\n","/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
